class PermitType {
    public Permit: number;
    public PermitName: string;
    public DSQRoot: string;
}

export { PermitType };
